import { apiRequest } from "../util/apiUtils";

export const publicationList = async (params) => {
  try {
    const res = await apiRequest("get", `publication/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const publicationAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `publication/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const publicationDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `publication/delete-all`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const publicationStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `publication/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
